import Container from 'layout/atoms/Container';
import Logo from 'layout/atoms/Logo';

import styles from './loader.module.scss';

interface Props {
    overlay?: boolean;
    withLogo?: boolean;
    initLoader?: boolean;
}

const Loader = ({ overlay, initLoader, withLogo }: Props) => {
    if (overlay) {
        return (
            <div className={styles.overlay}>
                <svg
                    className={styles.svg}
                    xmlns-svg="http://www.w3.org/2000/svg"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns-xlink="http://www.w3.org/1999/xlink"
                    version="1.0"
                    width="64px"
                    height="64px"
                    viewBox="0 0 128 128"
                    xml-space="preserve"
                >
                    <g>
                        <path
                            d="M75.4 126.63a11.43 11.43 0 0 1-2.1-22.65 40.9 40.9 0 0 0 30.5-30.6 11.4 11.4 0 1 1 22.27 4.87h.02a63.77 63.77 0 0 1-47.8 48.05v-.02a11.38 11.38 0 0 1-2.93.37z"
                            fill="#000000"
                        />
                        <animateTransform
                            attributeName="transform"
                            type="rotate"
                            from="0 64 64"
                            to="360 64 64"
                            dur="800ms"
                            repeatCount="indefinite"
                        ></animateTransform>
                    </g>
                </svg>
            </div>
        );
    }

    if (initLoader) {
        return (
            <Container>
                <div className={styles.initWrap}>
                    {withLogo && <Logo />}
                    <div className={styles.texts}>
                        <div className="loader-animation">
                            <p>loading...</p>
                            <p>connecting tasks with projects...</p>
                            <p>setting up somethiing else...</p>
                            <p>checking best possible ways...</p>
                            <p>calculating your gains...</p>
                            <p>setting up your goals...</p>
                            <p>we think something could go wrong</p>
                            <p>sorry for that</p>
                            <p>maybe try to reload the page</p>
                            <p>or try again later</p>
                        </div>
                    </div>
                </div>
            </Container>
        );
    }

    return (
        <div className={styles.wrap}>
            <svg
                xmlns-svg="http://www.w3.org/2000/svg"
                xmlns="http://www.w3.org/2000/svg"
                xmlns-xlink="http://www.w3.org/1999/xlink"
                version="1.0"
                width="64px"
                height="64px"
                viewBox="0 0 128 128"
                xml-space="preserve"
            >
                <g>
                    <path
                        d="M75.4 126.63a11.43 11.43 0 0 1-2.1-22.65 40.9 40.9 0 0 0 30.5-30.6 11.4 11.4 0 1 1 22.27 4.87h.02a63.77 63.77 0 0 1-47.8 48.05v-.02a11.38 11.38 0 0 1-2.93.37z"
                        fill="#000000"
                    />
                    <animateTransform
                        attributeName="transform"
                        type="rotate"
                        from="0 64 64"
                        to="360 64 64"
                        dur="800ms"
                        repeatCount="indefinite"
                    ></animateTransform>
                </g>
            </svg>
        </div>
    );
};

export default Loader;
